import React from "react";

/**
 * ローディングスピナーコンポーネント
 * @description 処理中のローディングを表示するコンポーネント
 */
const LoadingSpinner: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
    </div>
  );
};

export default LoadingSpinner;
